import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import TimelinePage from "@/sites/user/pages/timeline/index.vue";
import MyPage from "@/sites/user/pages/mypage/index.vue";
// search
import SearchGroupPage from "@/sites/user/pages/search/group.vue";
import SearchBlogPage from "@/sites/user/pages/search/blog.vue";
import SearchHashtagPage from "@/sites/user/pages/search/hashtag.vue";
// group
import GroupBlogPage from "@/sites/user/pages/group/blog.vue";
import GroupBlogDetailPage from "@/sites/user/pages/group/blogDetail.vue";
import GroupPhotoPage from "@/sites/user/pages/group/photo.vue";
import GroupAlbumPage from "@/sites/user/pages/group/album.vue";
import GroupAlbumDetailPage from "@/sites/user/pages/group/albumDetail.vue";
import GroupFilelPage from "@/sites/user/pages/group/file.vue";
import GroupNotFound from "@/sites/user/pages/group/notFound.vue";

import Login from "@/sites/user/pages/login.vue";
import CallbackLine from "@/sites/user/pages/callbackLine.vue";
import CallbackUpdateLine from "@/sites/user/pages/callbackUpdateLine.vue";

import SearchLayout from "@/sites/user/pages/search/template.vue";
import GroupLayout from "@/sites/user/pages/group/template.vue";

import ResetPassword from "@/sites/user/pages/resetPassword.vue";
import ResetPasswordExpired from "@/sites/user/pages/resetPasswordExpired.vue";

import UserLayout from "@/sites/user/layout/qMaster.vue";
import NonaviLayout from "@/sites/user/layout/qNoNavi.vue";
import store from "@/store";
Vue.use(VueRouter);

const userRouter: Array<RouteConfig> = [
  {
    path: "",
    name: "user",
    component: UserLayout,
    meta: {
      allowRole: [],
    },
    children: [
      {
        path: "/",
        name: "timeline",
        component: TimelinePage,
        meta: {
          allowRole: [],
          pageTitle:
            "【WENAVI】トワイライト・習い事・小学校・幼稚園・保育園などで利用できる会員制対応の情報発信サイト",
          title:
            "【WENAVI】トワイライト・習い事・小学校・幼稚園・保育園などで利用できる会員制対応の情報発信サイト",
          subTitle:
            "【WENAVI】トワイライト・習い事・小学校・幼稚園・保育園などで利用できる会員制対応の情報発信サイト",
          bodyClass: "Timeline",
          permission: [],
        },
      },
      {
        path: "login",
        name: "login",
        component: Login,
        meta: {
          allowRole: [],
          pageTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          title: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          subTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          bodyClass: "Group Mypage",
          permission: [],
        },
      },
      {
        path: "login/line/callback",
        name: "login.line.callback",
        component: CallbackLine,
        meta: {
          allowRole: [],
          pageTitle: "マイページ |【WENAVI】",
          title: "マイページ |【WENAVI】",
          subTitle: "マイページ |【WENAVI】",
          bodyClass: "Login Line",
          permission: [],
        },
      },
      {
        path: "line/update/callback",
        name: "line.update.callback",
        component: CallbackUpdateLine,
        meta: {
          allowRole: [],
          pageTitle: "マイページ |【WENAVI】",
          title: "マイページ |【WENAVI】",
          subTitle: "マイページ |【WENAVI】",
          bodyClass: "Update Line",
          permission: [],
        },
      },
      {
        path: "mypage",
        name: "mypage",
        component: MyPage,
        meta: {
          allowRole: [],
          pageTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          title: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          subTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          bodyClass: "Group Mypage",
          permission: [],
        },
      },
      {
        path: "search",
        name: "search",
        component: SearchLayout,
        meta: {
          allowRole: [],
        },
        children: [
          {
            path: "",
            name: "search.blog",
            component: SearchBlogPage,
            meta: {
              allowRole: [],
              pageTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
              title: "マイページ |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group Search",
              permission: [],
            },
          },
          {
            path: "group",
            name: "search.group",
            component: SearchGroupPage,
            meta: {
              allowRole: [],
              pageTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
              title: "マイページ |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group Search",
              permission: [],
            },
          },
          {
            path: "hashtag",
            name: "search.hashtag",
            component: SearchHashtagPage,
            meta: {
              allowRole: [],
              pageTitle: "検索 |【WENAVI】会員制対応の情報発信サイト",
              title: "検索 |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "検索 |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group Search",
              permission: [],
            },
          },
        ],
      },
      {
        path: "/group/:groupId/not-found",
        name: "group.notFound",
        component: GroupNotFound,
        meta: {
          allowRole: [],
          pageTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
          title: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
          subTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
          bodyClass: "Group",
          permission: [],
        },
      },
      {
        path: "group/:groupId",
        name: "group",
        component: GroupLayout,
        meta: {
          allowRole: [],
        },
        children: [
          {
            path: "",
            name: "group.blog",
            component: GroupBlogPage,
            meta: {
              allowRole: [],
              pageTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              title: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group",
              permission: [],
            },
          },
          {
            path: "blog/:id",
            name: "group.blog.detail",
            component: GroupBlogDetailPage,
            meta: {
              allowRole: [],
              pageTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              title: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group",
              permission: [],
            },
          },
          {
            path: "photo",
            name: "group.photo",
            component: GroupPhotoPage,
            meta: {
              allowRole: [],
              pageTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              title: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group",
              permission: [],
            },
          },
          {
            path: "album",
            name: "group.album",
            component: GroupAlbumPage,
            meta: {
              allowRole: [],
              pageTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              title: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group",
              permission: [],
            },
          },
          {
            path: "album/:id",
            name: "group.album.detail",
            component: GroupAlbumDetailPage,
            meta: {
              allowRole: [],
              pageTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              title: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group",
              permission: [],
            },
          },
          {
            path: "file",
            name: "group.file",
            component: GroupFilelPage,
            meta: {
              allowRole: [],
              pageTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              title: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              subTitle: "グループ名 |【WENAVI】会員制対応の情報発信サイト",
              bodyClass: "Group",
              permission: [],
            },
          },
        ],
      },
    ],
  },
  {
    path: "",
    name: "user",
    component: NonaviLayout,
    meta: {
      allowRole: [],
    },
    children: [
      {
        path: "/reset-password",
        name: "resetPassword",
        meta: {
          allowRole: [],
          pageTitle: "マイページ1 |【WENAVI】会員制対応の情報発信サイト",
          title: "マイページ2 |【WENAVI】会員制対応の情報発信サイト",
          subTitle: "マイページ3 |【WENAVI】会員制対応の情報発信サイト",
          bodyClass: "Group Mypage",
          permission: [],
          // layout: ,
          layout: "none",
        },
        component: ResetPassword,
      },
      {
        path: "/reset-password/expired",
        name: "resetPassword.expired",
        meta: {
          allowRole: [],
          pageTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          title: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          subTitle: "マイページ |【WENAVI】会員制対応の情報発信サイト",
          bodyClass: "Group Mypage",
          permission: [],
        },
        component: ResetPasswordExpired,
      },
    ],
  },
];

const routes = [...userRouter];
const router = new VueRouter({
  mode: "history",
  // base: process.env.NODE_ENV === "development" ? process.env.BASE_URL : "",
  routes,
});

router.beforeEach(async (to, from, next) => {
  store.dispatch("Router/setPreviousRouter", from);

  if (!to.name) {
    if (!store.state.MemberAuth.token) {
      next({
        name: "login",
      });
      return;
    } else {
      next({
        name: "mypage",
      });
      return;
    }
  }
  if (
    to.name != "login" &&
    to.name != "resetPassword" &&
    to.name != "login.line.callback" &&
    to.name != "search.blog" &&
    to.name != "search.group" &&
    to.name != "search.hashtag" &&
    to.name != "group" &&
    to.name != "group.blog" &&
    to.name != "group.blog.detail" &&
    to.name != "group.photo" &&
    to.name != "group.album" &&
    to.name != "group.album.detail" &&
    to.name != "group.file" &&
    !store.state.MemberAuth.token
  ) {
    next({
      name: "login",
    });
    return;
  }

  if (to.name == "login" && store.state.MemberAuth.token) {
    next({
      name: "mypage",
    });
    return;
  }

  next();
});

router.afterEach((to) => {
  // Use next tick to handle router history correctly
  // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
  Vue.nextTick(() => {
    document.title = to.meta.pageTitle || "";
    document.body.setAttribute("class", to.meta.bodyClass);
    document.body.setAttribute("draggable", "false");
    document.body.setAttribute("oncontextmenu", "return false;");
  });
});

export default router;
